import { styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  position: 'relative',
  width: '100%',
}));

export const Viewport = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
}));

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== '$offset',
})(({ $offset, theme }) => ({
  display: 'flex',
  gap: '20px',
  touchAction: 'pan-y',
  transition: 'transform 0.4s cubic-bezier(0.25, 0.1, 0.25, 1)',
  transform: `translateX(${$offset})`,
  willChange: 'transform',

  [theme.breakpoints.down('2xl')]: {
    gap: '16px',
  },
}));

export const Item = styled('div', {
  shouldForwardProp: (prop) => prop !== '$slidesPerView' && prop !== '$gap',
})(({ $slidesPerView, $gap }) => ({
  position: 'relative',
  flex: `0 0 calc((100% - ${($slidesPerView - 1) * $gap}px) / ${$slidesPerView})`,
  minWidth: 0,
}));

export const NavButton = styled('button')(({ theme, disabled }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '72px',
  height: '72px',
  minWidth: '72px',
  padding: 0,
  border: 'none',
  borderRadius: '50%',
  outline: 'none',
  cursor: disabled ? 'default' : 'pointer',
  color: theme.palette.color.fg.primary,
  backgroundColor: theme.palette.color.global.card,
  opacity: disabled ? 0.4 : 1,
  pointerEvents: disabled ? 'none' : 'auto',
  transition: 'background-color 0.3s ease, opacity 0.3s ease',

  '&:hover:not(:disabled)': {
    backgroundColor: theme.palette.color.surface.modalTetriaryHover,
  },

  '& svg': {
    width: '32px',
    height: '32px',

    [theme.breakpoints.down('2xl')]: {
      width: '24px',
      height: '24px',
    },
    [theme.breakpoints.down('md')]: {
      width: '20px',
      height: '20px',
    },
  },

  [theme.breakpoints.down('2xl')]: {
    width: '60px',
    height: '60px',
    minWidth: '60px',
  },
  [theme.breakpoints.down('md')]: {
    width: '40px',
    height: '40px',
    minWidth: '40px',
  },
}));

export const ChevronLeft = styled('span')(() => ({
  display: 'flex',
  transform: 'scaleX(-1)',
}));

export const Nav = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '20px',
  marginTop: '72px',

  [theme.breakpoints.down('2xl')]: {
    marginTop: '44px',
  },
  [theme.breakpoints.down('lg')]: {
    marginTop: '40px',
  },
  [theme.breakpoints.down('md')]: {
    marginTop: '36px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '32px',
  },
}));
